/*
 * This image is the same as component/radioOn.ts, except that its outline is allowed to change color (with the fill color).
 */
export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25Zm0 1.5a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM12 6a6 6 0 1 1 0 12 6 6 0 0 1 0-12Z"/>
</svg>
`;
